// Third party libraries
import { MouseEvent } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Icon } from 'semantic-ui-react';

// Locales
import I18n from "../../../../i18n";

// Redux
import { closeLoader, openLoader } from '../../../../redux-store/loader';

// Models
import StudentModel from '../../../../models/student';

// Styles
import "./itemStudentGroups.scss";

interface ItemGroupInterface {
  _id: string;
  name: string;
}

type Props = {
  userId: string;
  groups: ItemGroupInterface[];
  refresh?: () => void;
};

export default function ItemStudentGroups({ userId, groups, refresh }: Props) {
  const dispatch = useDispatch();

  const handleRemoveGroup = async (event: MouseEvent, groupId: string) => {
    event.stopPropagation();

    dispatch(openLoader());

    try {

        await StudentModel.unassignGroup(userId, groupId);

        refresh && refresh();

    } catch (e) {
        console.error("Error removing group:", e);
    }

    dispatch(closeLoader());
  };

  return (
    <div className="itemStudentGroups">
      <span>{I18n.t("menu.groups")}:</span>
      {groups.length > 0 ? (
        <ul>
          {groups.map((group, index) => (
            <li key={group._id}>
              <Link
                to={`/groups/edit/${group._id}`}
                onClick={(e) => e.stopPropagation()}
              >
                {group.name}
              </Link>
              <button
                title={I18n.t("groups.deleteUser")}
                onClick={(event) => handleRemoveGroup(event, group._id)}
              >
                <Icon name="remove" />
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p>{I18n.t("groups.noGroups")}</p>
      )}
    </div>
  );
}
